module.exports = __webpack_public_path__ + "static/img/back.952950b9.png";